import { Pipe, PipeTransform } from '@angular/core';
import { CountryPipe } from './country.pipe';

// "(sigla afiliação, País)" — formato único do rótulo de afiliação do usuário,
// usado em vários pontos (find-reviewers, chat de discussão, etc.). Usa a sigla
// real da afiliação quando existe; senão normaliza o nome (title-case). País via
// CountryPipe. Retorna '' quando não há dados (sem parênteses vazios).
@Pipe({ name: 'userAffiliation' })
export class UserAffiliationPipe implements PipeTransform {

  private connectors = new Set(['de', 'da', 'do', 'das', 'dos', 'e', 'of', 'the', 'for', 'and', 'a', 'à']);

  constructor(private countryPipe: CountryPipe) { }

  transform(user: any): string {
    const profile = user && user.profile;
    if (!profile) { return ''; }
    const aff = profile.affiliation;
    let label = '';
    if (aff) {
      label = (aff.acronym && aff.acronym !== aff.name) ? aff.acronym : this.formatAffiliation(aff.name);
    }
    const country = profile.country ? this.countryPipe.transform(profile.country) : '';
    const parts = [label, country].filter(v => !!v);
    return parts.length ? `(${parts.join(', ')})` : '';
  }

  // Afiliação vem do backend com CAIXA inconsistente (tudo maiúsculo ou misto).
  // Normaliza p/ title-case preservando siglas curtas (USP, UFC), tokens já
  // mistos (UnB/FGA, "Federal University…") e conectores (de/do/da/of…).
  private formatAffiliation(name: string): string {
    if (!name) { return ''; }
    return name.trim().split(/\s+/).map((w, i) => {
      if (w.indexOf('/') >= 0) { return w; }                       // ex.: UnB/FGA
      if (/[a-zà-ÿ]/.test(w) && /[A-ZÀ-Ý]/.test(w)) { return w; }  // já misto (ex.: Federal)
      const lower = w.toLowerCase();
      if (i > 0 && this.connectors.has(lower)) { return lower; }
      if (w.length <= 4 && w === w.toUpperCase()) { return w; }    // sigla curta (USP, UFC, PUC)
      return lower.charAt(0).toUpperCase() + lower.slice(1);
    }).join(' ');
  }
}
